import { render, staticRenderFns } from "./Theme4Section4.vue?vue&type=template&id=056dc026&scoped=true&"
import script from "./Theme4Section4.vue?vue&type=script&lang=js&"
export * from "./Theme4Section4.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Section4.vue?vue&type=style&index=0&id=056dc026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056dc026",
  null
  
)

export default component.exports